import { MotifIcon } from '@ey-xd/motif-react'
import React from 'react'
import iconSvg from "../../assets/icons/icon.svg.json";

const FileDownload = (props: any) => {
    const {
        name, link
    } = props;
  return (
    <div className="flex justify-between !w-full border-b border-[#7f7f7f61]  pb-2">
        <span className="bg-[#747480]/20 px-2 !text-sm flex items-center">{name}</span>
        <MotifIcon onClick={() => {
          window.open(link, '_self');
        }} src={iconSvg["download-file-icon"]} className="!w-4 !cursor-pointer" title='download-file-icon' />
    </div>
  )
}

export default FileDownload